'use strict';

angular.module('paizacloudApp')
  .directive('editorView', function($timeout, $filter, Language, Upload, $cookies, $http, Auth, openApplicationMenu) {
    /*
    window.requirejs.config({
      paths: {
        ace: "https://cdnjs.cloudflare.com/ajax/libs/ace/1.2.6",
      },
    });
    */
    // const useragent = window.ace.require("ace/lib/useragent");
    // useragent.iOS = false;

    const Autocomplete = window.ace.require("ace/autocomplete").Autocomplete;
    const util = window.ace.require("ace/autocomplete/util");
    /*
    window.ace.require("ace/config").set("workerPath",
      "bower_components/ace-builds/src-min-noconflict");
    window.ace.require("ace/config").set("basePath",
      "bower_components/ace-builds/src-min-noconflict");
    */

    window.ace.require("ace/config").set("workerPath", "https://ajaxorg.github.io/ace-builds/src-noconflict");
    window.ace.require("ace/config").set("basePath", "https://ajaxorg.github.io/ace-builds/src-noconflict");
    /*
    window.ace.require("ace/config").set("workerPath", "/ace-builds/src-noconflict");
    window.ace.require("ace/config").set("basePath", "/ace-builds/src-noconflict");
     */

    /*
    const VimApi = window.ace.require("ace/keyboard/vim").CodeMirror.Vim;
    VimApi.defineEx("write", "w", (cm, input) => {
      cm.ace.execCommand("save");
    });
    */

    // const WorkerClient = window.ace.require("ace/worker/worker_client").WorkerClient;

    const language_tools = window.ace.require("ace/ext/language_tools");
    const Emmet = window.ace.require("ace/ext/emmet");

    Emmet.setCore(window.emmet);
    /*
    var Autocomplete = window.ace.acequire("ace/autocomplete").Autocomplete;
    var util = window.ace.acequire("ace/autocomplete/util");
    // window.ace.acequire("ace/config").set("workerPath",
    //  "bower_components/ace-builds/src-min-noconflict");
    //window.ace.acequire("ace/config").set("basePath",
    //  "bower_components/ace-builds/src-min-noconflict");
    var language_tools = window.ace.acequire("ace/ext/language_tools");
    */
    /*
    var Autocomplete = require("brace/autocomplete").Autocomplete;
    var util = require("brace/autocomplete/util");
    //window.ace.require("brace/config").set("workerPath",
      //"bower_components/ace-builds/src-min-noconflict");
    //window.ace.require("brace/config").set("basePath",
      //"bower_components/ace-builds/src-min-noconflict");
    var language_tools = window.ace.require("brace/language_tools");
    */

    language_tools.setCompleters([language_tools.textCompleter, language_tools.keyWordCompleter, language_tools.snippetCompleter]);

    function myDoLiveAutocomplete(e){
      console.log("myDoLiveAutocomplete:", e);
      let editor = e.editor;
      let hasCompleter = editor.completer && editor.completer.activated;
      if (e.command.name === "backspace") {
        if (hasCompleter && !util.getCompletionPrefix(editor)){
          editor.completer.detach();
        }
      }else if (e.command.name === "insertstring") {
        let prefix = util.getCompletionPrefix(editor);
        if (prefix && !hasCompleter) {
          if (!editor.completer) {
            editor.completer = new Autocomplete();
          }
          editor.completer.autoInsert = false;
          editor.completer.autoSelect = false;
          editor.completer.exactMatch = true;
          editor.completer.showPopup(editor);
          // setTimeout(function(){
          //  editor.completer.popup.selection.clearSelection();
          // },1000);
          // editor.completer.popup.session.$backMarkers[2].range.start.row = -1;
          // editor.completer.popup.session.$backMarkers[2].range.end.row = -1;
        }
      }
    }

    function hookAceTokenizer(){
      /*
      var highlightTokens = function(tokens){
          var newTokens = [];
          var re = this.doc.highlightRegExp;
          tokens.forEach(function(token){
            var match;
            var cur_pos = 0;
            while((match = re.exec(token.value))!==null){
              newTokens.push({type: token.type, value: token.value.substr(cur_pos, match.index - cur_pos)});
              cur_pos += (match.index - cur_pos);
              newTokens.push({type: 'highlight', value: token.value.substr(cur_pos, match[0].length)});
              cur_pos += match[0].length;
            }
            newTokens.push({type: token.type, value: token.value.substr(cur_pos)});
            cur_pos += token.value.length - cur_pos;
          });
          return newTokens;
      };
      */
      let BackgroundTokenizer = window.ace.require("ace/background_tokenizer").BackgroundTokenizer;
      // var BackgroundTokenizer = window.ace.BackgroundTokenizer;
      let origTokenizeRow = BackgroundTokenizer.prototype.$tokenizeRow;

      function getLineTokensWithHighlight(line, startState, row){
        let re = this.highlightRegExp;
        if(!re){
          let data2 = this.constructor.prototype.getLineTokens.call(this, line, startState, row);
          return data2;
        }

        let state = startState;

        let match;
        let cur_pos = 0;
        let str;
        let data;
        let newTokens:any[] = [];
        while((match = re.exec(line)) !== null){

          str = line.substr(cur_pos, match.index - cur_pos);
          data = this.constructor.prototype.getLineTokens.call(this, str, state, row);
          Array.prototype.push.apply(newTokens, data.tokens);
          state = data.state;
          cur_pos += str.length;

          str = line.substr(cur_pos, match[0].length);
          newTokens.push({type: 'highlight', value: str});
          cur_pos += str.length;
        }
        str = line.substr(cur_pos);
        data = this.constructor.prototype.getLineTokens.call(this, str, state, row);
        Array.prototype.push.apply(newTokens, data.tokens);
        state = data.state;
        cur_pos += str.length;

        return {
          tokens: newTokens,
          state: state,
        };
      }

      BackgroundTokenizer.prototype.$tokenizeRow = function(row){
        let origGetLineTokens = this.tokenizer.getLineTokens;
        this.tokenizer.getLineTokens = getLineTokensWithHighlight;
        this.tokenizer.highlightRegExp = this.doc.highlightRegExp;
        let tokens = origTokenizeRow.apply(this, arguments);
        delete this.tokenizer.getLineTokens;
        // this.tokenizer.constructor.prototype.getLineTokens = origGetLineTokens;
        delete this.tokenizer.highlightRegExp;

        return tokens;
        /*
        var re = this.doc.highlightRegExp;

        var line = this.doc.getLine(row);
        var state = this.states[row - 1];

        var match;
        var cur_pos = 0;
        var str, data;
        var newTokens = [];
        while((match = re.exec(row))!==null){

          str = line.substr(cur_pos, match.index - cur_pos);
          data = this.tokenizer.getLineTokens(str, state, row);
          Array.prototype.push.apply(newTokens, data.tokens);
          state = data.state;
          cur_pos += str.length;

          str = line.substr(cur_pos, match[0].length);
          newTokens.push({type: 'highlight', value: str});
          cur_pos += str.length;
        }
        str = line.substr(cur_pos, match.index - cur_pos);
        data = this.tokenizer.getLineTokens(str, state, row);
        Array.prototype.push.apply(newTokens, data.tokens);
        state = data.state;
        cur_pos += str.length;

        if (this.states[row] + "" !== data.state + "") {
            this.states[row] = data.state;
            this.lines[row + 1] = null;
            if (this.currentLine > row + 1){
                this.currentLine = row + 1;
            }
        } else if (this.currentLine === row) {
            this.currentLine = row + 1;
        }
        return (this.lines[row] = data.tokens);
        */
      };
    }

    // csv描画時にエラーになるため一旦コメントアウト
    // https://paiza.slack.com/archives/CMAKCCMR6/p1741820682219659
    // hookAceTokenizer();

    function setHighlight(editor, highlightRegExp){
      if(!highlightRegExp){
        return;
      }
      editor.session.doc.highlightRegExp = new RegExp(highlightRegExp, "g");

      /*
      var origTokenizeRow = editor.session.bgTokenizer.$tokenizeRow;
      editor.session.bgTokenizer.$tokenizeRow = function(row){
        var tokens = origTokenizeRow.apply(this, arguments);
        var newTokens = this.doc.highlightTokens(tokens);
        return (this.lines[row] = newTokens);
      };
      editor.session.doc.highlightTokens = highlightTokens;
      */

      /*
      var origGetLineTokens = editor.session.getMode().getTokenizer().getLineTokens;

      editor.session.$mode = Object.create(editor.session.$mode);
      editor.session.$mode.hoge = true;
      editor.session.$mode.$tokenizer = Object.create(editor.session.$mode.$tokenizer);
      editor.session.$mode.$tokenizer.hoge = true;
      editor.session.bgTokenizer = Object.create(editor.session.bgTokenizer);
      editor.session.bgTokenizer.hoge = true;
      editor.session.bgTokenizer.tokenizer = editor.session.$mode.$tokenizer;

      editor.session.$mode.$tokenizer.getLineTokens = function(line, startState, row){
        var data = origGetLineTokens.apply(this, arguments);
        var newTokens = highlightTokens(data.tokens);
        data.tokens = newTokens;
        return data;
      };
      */
    }

    const modelist = window.ace.require("ace/ext/modelist");
    return {
      template: require('./editorview.directive.html').default,
      restrict: 'EA',
      // require: '^ngModel',
      scope: {
        ngModel: '=',
        container: '=',
        controller: '=',
      },
      link: {
        pre: function(scope, element, attrs) {
          scope.ngModel.iconText = '📄';
          console.log("editorview: pre");

          scope.aceOptions = {
            enableSnippets: true,
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: false,
          };

          scope.aceEditorThemes = [
            {
              key: "chrome",
              name: "Chrome",
              shade: "Bright",
            }, {
              key: "clouds",
              name: "Clouds",
              shade: "Bright",
            }, {
              key: "crimson_editor",
              name: "Crimson Editor",
              shade: "Bright",
            }, {
              key: "dawn",
              name: "Dawn",
              shade: "Bright",
            }, {
              key: "dreamweaver",
              name: "Dreamweaver",
              shade: "Bright",
            }, {
              key: "eclipse",
              name: "Eclipse",
              shade: "Bright",
            }, {
              key: "katzenmilch",
              name: "KatzenMilch",
              shade: "Bright",
            }, {
              key: "kuroir",
              name: "Kuroir",
              shade: "Bright",
            }, {
              key: "github",
              name: "GitHub",
              shade: "Bright",
            }, {
              key: "solarized_light",
              name: "Solarized Light",
              shade: "Bright",
            }, {
              key: "textmate",
              name: "TextMate",
              shade: "Bright",
            }, {
              key: "tomorrow",
              name: "Tomorrow",
              shade: "Bright",
            }, {
              key: "xcode",
              name: "XCode",
              shade: "Bright",
            }, {
              key: "ambiance",
              name: "Ambiance",
              shade: "Dark",
            }, {
              key: "chaos",
              name: "Chaos",
              shade: "Dark",
            }, {
              key: "clouds_midnight",
              name: "Clouds Midnight",
              shade: "Dark",
            }, {
              key: "cobalt",
              name: "Cobalt",
              shade: "Dark",
            }, {
              key: "idle_fingers",
              name: "idle_fingers",
              shade: "Dark",
            }, {
              key: "kr",
              name: "kr",
              shade: "Dark",
            }, {
              key: "kr_theme",
              name: "krTheme",
              shade: "Dark",
            }, {
              key: "merbivore",
              name: "Merbivore",
              shade: "Dark",
            }, {
              key: "merbivore_soft",
              name: "Merbivore Soft",
              shade: "Dark",
            }, {
              key: "mono_industrial",
              name: "Mono Industrial",
              shade: "Dark",
            }, {
              key: "monokai",
              name: "Monokai",
              shade: "Dark",
            }, {
              key: "pastel_on_dark",
              name: "Pastel on Dark",
              shade: "Dark",
            }, {
              key: "solarized_dark",
              name: "Solarized Dark",
              shade: "Dark",
            }, {
              key: "terminal",
              name: "Terminal",
              shade: "Dark",
            }, {
              key: "tomorrow_night",
              name: "Tomorrow Night",
              shade: "Dark",
            }, {
              key: "tomorrow_night_blue",
              name: "Tomorrow Night Blue",
              shade: "Dark",
            }, {
              key: "tomorrow_night_bright",
              name: "Tomorrow Night Bright",
              shade: "Dark",
            }, {
              key: "tomorrow_night_eighties",
              name: "Tomorrow Night 80s",
              shade: "Dark",
            }, {
              key: "twilight",
              name: "Twilight",
              shade: "Dark",
            }, {
              key: "vibrant_ink",
              name: "Vibrant Ink",
              shade: "Dark",
            },
          ];

          scope.aceLoaded = function(_editor){
            console.log("editorview: aceLoaded");
            scope.ace = _editor;
            scope.ace.commands.on('afterExec', (e) => {
              if(scope.aceOptions.enableBasicAutocompletion) {
                myDoLiveAutocomplete(e);
              }
            });
            scope.ace.commands.on('afterExec', function(e){
              // console.log("afterExec:", e);
              if(!scope.isClean()){
                scope.autosave();
              }
            });
            const yenCommand = {
              name: "yen",
              bindKey: {win: "¥", mac: "¥"},
              exec: (editor) => {
                scope.ace.insert("\\");
              },
            };
            scope.ace.commands.addCommand(yenCommand);

            const iOSQuoteCommand1 = {
              name: "iOSQuote1",
              bindKey: {win: "’", mac: "’"},
              exec: (editor) => {
                scope.ace.insert("'");
              },
            };
            scope.ace.commands.addCommand(iOSQuoteCommand1);

            const iOSQuoteCommand2 = {
              name: "iOSQuote2",
              bindKey: {win: "‘", mac: "‘"},
              exec: (editor) => {
                scope.ace.insert("'");
              },
            };
            scope.ace.commands.addCommand(iOSQuoteCommand2);

            const iOSDoubleQuoteCommand1 = {
              name: "iOSDoubleQuote1",
              bindKey: {win: "”", mac: "”"},
              exec: (editor) => {
                scope.ace.insert('"');
              },
            };
            scope.ace.commands.addCommand(iOSDoubleQuoteCommand1);

            const iOSDoubleQuoteCommand2 = {
              name: "iOSDoubleQuote2",
              bindKey: {win: "“", mac: "“"},
              exec: (editor) => {
                scope.ace.insert('"');
              },
            };
            scope.ace.commands.addCommand(iOSDoubleQuoteCommand2);

            const saveCommand = {
              name: "save",
              exec: (editor) => {
                scope.onSave();
              },
            };
            scope.ace.commands.addCommand(saveCommand);

            const quitCommand = {
              name: "quit",
              exec: (editor) => {
                scope.$emit("application:close");
              },
            };
            scope.ace.commands.addCommand(quitCommand);

            let highlightRegExp = scope.ngModel.highlightRegExp;
            // var highlightRegExp = 'hoge|huga|\\*\\*\\*.*\\*\\*\\*';
            setHighlight(scope.ace, highlightRegExp);

            const aceElement = element.find(".editorview")[0];
            aceElement.addEventListener('copy', () => {
              console.log('editorview:copy');
              if(scope.ace.selection.isEmpty()){
                scope.ace.selection.selectLine();
              }
            }, true);
            aceElement.addEventListener('cut', () => {
              console.log('editorview:cut');
              if(scope.ace.selection.isEmpty()){
                scope.ace.selection.selectLine();
              }
            }, true);

            // https://github.com/ajaxorg/ace/issues/3160#issuecomment-732140145
            const changeOptionsForJavaScript = (e, session) => {
              if (session.getMode().$id === "ace/mode/javascript") {
                if (session.$worker) {
                  session.$worker.send("setOptions", [{
                    "esversion": 10,
                    "esnext": false,
                    browser: true,
                    node: true,
                    devel: true,
                    jquery: true,
                    // globals: {window: true},
                  }]);
                }
              }
            };
            scope.ace.session.on("changeMode", changeOptionsForJavaScript);
            changeOptionsForJavaScript(null, scope.ace.session);

            /*
            _editor.session.$mode.$tokenizer.wrapped = true;
            _editor.session.$mode.$tokenizer.getLineTokens = function(line, startState, row){
              var data = origGetLineTokens.apply(this, arguments);
              var foundKeyword;
              _editor.session.$mode.$tokenizer.highlightKeywords.forEach(function(keyword){
                if(keyword.editor.isFocused()){
                  foundKeyword = keyword;
                }
              });
              if(foundKeyword){
                var newTokens = highlightTokens(data.tokens, foundKeyword.reg);
                data.tokens = newTokens;
              }
              return data;
            };
            _editor.session.$mode.$tokenizer.setHighlightKeywords = function(editor, reg){
              _editor.session.$mode.$tokenizer.highlightKeywords = _editor.session.$mode.$tokenizer.highlightKeywords || [];
              _editor.session.$mode.$tokenizer.highlightKeywords.push({editor: editor, reg: reg});
            };

            _editor.session.$mode.$tokenizer.setHighlightKeywords({editor: _editor, reg: 'foo'});
            */

          };

          let aceChangedTimer;
          let lastSaveTime = 0;
          scope.autosave = function(){
            if(!scope.ngModel.autosave){
              return;
            }
            if(aceChangedTimer){
              $timeout.cancel(aceChangedTimer);
            }
            let delay = Math.max(500, lastSaveTime + 3000 - Date.now());
            aceChangedTimer = $timeout(function(){
              aceChangedTimer = null;
              scope.onSave();
              lastSaveTime = Date.now();
            }, delay);
          };

          scope.aceChanged = function(e){
            // console.log("aceChanged", e);
            scope.autosave();
          };

          console.log("filename=", scope.ngModel.filename);
          let acemode = modelist.getModeForPath(scope.ngModel.filename).name;
          // require('brace/mode/' + acemode);
          scope.acemode = acemode;
        },
        post: function(scope, element, attrs) {
          function getTitleFilename(filename){
            if(filename.startsWith("/home/ubuntu")){
              filename = "~" + filename.substr("/home/ubuntu".length);
            }
            const basename = filename.split('/').pop();
            return {
              text: filename,
              shortText: basename,
            };
          }
          let filename = scope.ngModel.filename;
          function load(){
            scope.busy = true;
            const cursorPos = scope.ace && scope.ace.getCursorPosition && scope.ace.getCursorPosition();
            scope.container.socket.emit('readFile', filename, {encoding: 'utf8'}, (err, data) => {
              scope.busy = false;
              if(err){
                console.error('readFile failed:', err);
                if(!scope.loaded && err.code === 'ENOENT'){
                  scope.ngModel.model = '';
                  scope.loaded = true;
                  scope.onSave();
                }
                return;
              }
              if(scope.loaded && scope.ngModel.model !== data) {
                if(scope.isClean()){
                  scope.ngModel.model = data;
                  scope.loaded = true;
                  if(cursorPos) {
                    $timeout(() => {
                      scope.ace.selection.moveTo(cursorPos.row, cursorPos.column);
                    }, 200);
                  }
                }else{
                  window.swal({
                    type: 'warning',
                    title: $filter('translate')('EDITOR_RELOAD_ALERT_TITLE'),
                    text: $filter('translate')('EDITOR_RELOAD_ALERT_TEXT', {filename: scope.ngModel.filename}),
                    showCancelButton: true,
                    focusCancel: true,
                    // confirmButtonText: $filter('translate')('DELETE'),
                    cancelButtonText: $filter('translate')('CANCEL'),
                    // confirmButtonColor: "#D9534E",
                    // input: 'checkbox',
                    // inputPlaceholder: "Do not show this again.",
                  }).then((doNotShowAgain_) => {
                    // scope.doNotShowReloadAlert = doNotShowAgain_;
                    scope.ngModel.model = data;
                    scope.loaded = true;
                    if(cursorPos) {
                      $timeout(() => {
                        scope.ace.selection.moveTo(cursorPos.row, cursorPos.column);
                      }, 200);
                    }
                    scope.markClean();
                  });
                }
              }else{
                scope.ngModel.model = data;
                scope.loaded = true;
              }
            });
          }
          scope.$watch('container.containerId', function(post, pre){
            if(!post){
              unwatch();
              return;
            }
            load();
            /*
            scope.container.getFile(filename).then(function(response){
              scope.ngModel.model = response.data;
            }).catch((error) => {
              console.log('getFile failed.', error);
              scope.onSave();
            });
            */
            watch();
          });

          let watchEventTimer;
          let watchEventId;
          function watchEventCallback(eventId, filename_){
            console.log('watch event callback', eventId, event, filename_);
            if(scope.suspendWatch){
              return;
            }
            $timeout.cancel(watchEventTimer);
            watchEventTimer = $timeout(() => {
              load();
            }, 1000);
          }
          function watch(){
            console.log('watch start');
            unwatch();
            scope.container.socket.emit('watch', filename, {parent: true}, (err, eventId) => {
              if(err){
                console.error(`watch(${filename}) error`, err);
                window.alert(`watch(${filename}) error:` + JSON.stringify(err, null, 2));
              }
              let timer;
              watchEventId = eventId;

              scope.container.socket.on(eventId, watchEventCallback);
            });

            scope.container.socket.removeListener('reconnect', watch);
            scope.container.socket.on('reconnect', watch);
            scope.container.socket.removeListener('connect_error', unwatch);
            scope.container.socket.on('connect_error', unwatch);
          }
          function unwatch(){
            console.log('unwatch ', watchEventId);
            if(watchEventId) {
              if(scope.container.socket){
                scope.container.socket.removeListener(watchEventId, watchEventCallback);
                scope.container.socket.emit('unwatch', watchEventId, () => {
                  console.log('unwatch done', watchEventId);
                });
              }
              watchEventId = null;
            }
            if(scope.container.socket) {
              scope.container.socket.removeListener('connect_error', unwatch);
            }
          }
          scope.$on('$destroy', () => {
            if(scope.container.socket) {
              scope.container.socket.removeListener('reconnect', watch);
            }
            unwatch();
          });

          /*
          scope.container.socket.emit('readFile', scope.ngModel.filename, {}, function(err, data){
            if(err){
              window.swal('Editor Error:' + (err.message || JSON.stringify(err)), 'error...', 'error');
              return;
            }

            // http://stackoverflow.com/a/17192845/1309218
            // Conversion between UTF-8 ArrayBuffer and String

            function stringToUint(string) {
                // var string = btoa(unescape(encodeURIComponent(string))),
                    var charList = string.split(''),
                    uintArray = [];
                for (var i = 0; i < charList.length; i++) {
                    uintArray.push(charList[i].charCodeAt(0));
                }
                return new Uint8Array(uintArray);
            }

            function uintToString(uintArray) {
                // jshint nonstandard:true
                var encodedString = String.fromCharCode.apply(null, uintArray),
                    decodedString = decodeURIComponent(escape(encodedString));
                return decodedString;
            }

            var body = atob(data);
            var uintArray = stringToUint(body);
            var body2 = uintToString(uintArray);
            scope.ngModel.model = body2;
          });
          */

          scope.$watch('controller', (post, pre) => {
            if(scope.controller){
              scope.controller.onbeforeunload = function(){
                if(! scope.isClean()){
                  let confirm_leave = "Your code is not saved. Are you sure you want to close the file ?";
                  return confirm_leave;
                }
              };
            }
          });

          scope.$on('focus', function(event, ev){
            scope.ace.focus();
          });

          {
            let timer;
            scope.$on('resize', function(event, ev){
              console.log("resize:event, ev=", event, ev);
              $timeout.cancel(timer);
              timer = $timeout(function(){
                resize();
                timer = null;
              }, 300);
            });
          }

          function resize(){
            scope.ace.resize();
          }
          scope.isClean = function(){
            return scope.ace.session.getUndoManager().isClean();
          };
          function updateTitle(){
            let title = getTitleFilename(scope.ngModel.filename);
            /*
            if(!scope.isClean()){
              title += " - Editing";
            }
            */
            scope.$emit('title', title);
          }
          updateTitle();
          scope.$watch("isClean()", function(post, pre){
            updateTitle();
          });
          scope.markClean = function(){
            scope.ace.session.getUndoManager().markClean();
          };

          element.on('keydown', function(ev){
            if((ev.metaKey || ev.ctrlKey) && String.fromCharCode(ev.keyCode) === 'S'){ // 83
              console.log('keypress:', ev);
              scope.$apply(function(){
                scope.onSave();
              });
              ev.preventDefault();
            }
          });

          /*
          scope.keydown = function(ev){
            if((ev.metaKey || ev.ctrlKey) && String.fromCharCode(ev.keyCode)==='S'){ // 83
              console.log('keypress:', ev);
              scope.onSave();
              ev.preventDefault();
            }
          };
          */

          /*
          scope.keypress = function(ev){
            console.log('keypress:', ev);
            if((ev.metaKey || ev.ctrlKey) && String.fromCharCode(ev.keyCode)==='s' ){ // 115
              scope.onSave();
              ev.preventDefault();
            }
          };
          */

          scope.onSave = () => {
            if(! scope.loaded){
              return;
            }
            let filename = scope.ngModel.filename;
            let model = scope.ngModel.model;
            let pos = filename.lastIndexOf('/');
            let target = filename.substr(0, pos);

            scope.suspendWatch = true;
            scope.container.socket.emit('writeFile', filename, model, null, (error) => {
              if(error){
                console.log('writeFile error:', error);
                if(error.code === 'EACCES'){
                  return window.swal({
                    title: $filter('translate')('SAVE_ERROR_ALERT_EACCES_TITLE'),
                    html: $filter('translate')('SAVE_ERROR_ALERT_EACCES_TEXT') + '<br>(' + error.message + ')',
                    type: "warning",
                    showCancelButton: true,
                    // confirmButtonColor: "#DD6B55",
                    confirmButtonText: $filter('translate')('SAVE_AS_ROOT'),
                    cancelButtonText: $filter('translate')('CANCEL'),
                  })
                    .then(() => {
                      scope.container.socket.emit('writeFile', filename, model, {user: 'root', group: 'root'}, (error) => {
                        if(error){
                          console.log('writeFile error:', error);
                          window.swal('Error', error.message, 'error');
                        }
                        scope.loaded = true;
                        scope.markClean();
                        $timeout(() => {
                          scope.suspendWatch = false;
                        }, 1000);
                      });
                    })
                    .catch((error) => {
                      scope.suspendWatch = false;
                    });
                }
                window.swal('Error', error.message, 'error');
                scope.suspendWatch = false;
                return;
              }
              scope.loaded = true;
              scope.markClean();
              $timeout(() => {
                scope.suspendWatch = false;
              }, 1000);
            });
            /*
            var blob = new Blob([model], {type: 'text/plain', name: filename});
            blob.name = filename;
            uploadFiles(scope.container, blob, target);
            */
          };

          function uploadFiles(container, files, target) {
            console.log("uploadFiles: container=", container);
            console.log("uploadFiles: files=", files);
            console.log("uploadFiles: target=", target);

            let url = '/api/containers/' + container._id + '/upload';
            Upload.upload({
              url: url,
              data: {
                files: files,
                "Content-Type": 'application/octet-stream',
                target: target,
              },
            })
              .progress(function(evt){
                let progressPercentage = Math.floor(100 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage);
              })
              .success(function(data, status, headers, config){
                console.log('file uploaded:', arguments);
              })
              .error(function(data, status, headers, config){
                console.log('Error status: ', status);
              });
          }

          scope.contextmenu = {};
          scope.$on('showApplicationMenu', (event, domEvent, source) => {
            console.log('$on:showApplicationMenu', event, domEvent, source);
            openApplicationMenu(scope, '.editorview-dropdown-menu', domEvent);
          });

          let appConfig;

          scope.setFontSize = (fontSize) => {
            appConfig.general.fontSize = fontSize;
            scope.currentUser.saveApplicationConfigs();
          };
          scope.setTabSize = (tabSize) => {
            appConfig.general.tabSize = tabSize;
            scope.currentUser.saveApplicationConfigs();
          };
          scope.setKeyboardHandler = (keyboardHandler) => {
            appConfig.general.keyboardHandler = keyboardHandler;
            scope.currentUser.saveApplicationConfigs();
          };
          scope.setTheme = (theme) => {
            appConfig.general.theme = theme;
            scope.currentUser.saveApplicationConfigs();
          };
          scope.enableEmmet = (enableEmmet) => {
            appConfig.general.enableEmmet = enableEmmet;
            scope.currentUser.saveApplicationConfigs();
          };
          scope.useWrapMode = (useWrapMode) => {
            appConfig.general.useWrapMode = useWrapMode;
            scope.currentUser.saveApplicationConfigs();
          };

          Auth.getCurrentUser((user) => {
            scope.currentUser = user;
            scope.currentUser.applicationConfigs = scope.currentUser.applicationConfigs || {};
            scope.appConfig = appConfig = scope.currentUser.applicationConfigs.editor = scope.currentUser.applicationConfigs.editor || {};
            appConfig.general = appConfig.general || {};

            scope.$watch('currentUser.applicationConfigs.editor.general.fontSize', (post, pre) => {
              if(!post){
                return;
              }
              const fontSize = appConfig.general.fontSize;
              if (scope.aceOptions.fontSize !== `${fontSize}px`){
                scope.aceOptions.fontSize = `${fontSize}px`;
                resize();
              }
            });
            scope.$watch('currentUser.applicationConfigs.editor.general.tabSize', (post, pre) => {
              if(!post){
                return;
              }
              const tabSize = appConfig.general.tabSize;
              if (scope.aceOptions.tabSize !== tabSize){
                scope.aceOptions.tabSize = tabSize;
                resize();
              }
            });
            scope.$watch('currentUser.applicationConfigs.editor.general.keyboardHandler', (post, pre) => {
              if(!post){
                return;
              }
              const keyboardHandler = appConfig.general.keyboardHandler;
              if (scope.aceOptions.keyboardHandler !== keyboardHandler){
                if(keyboardHandler === 'normal'){
                  scope.ace.setKeyboardHandler(null);
                }else{
                  scope.ace.setKeyboardHandler(`ace/keyboard/${keyboardHandler}`);
                  if(keyboardHandler === 'vim'){
                    window.ace.require("ace/config").loadModule("ace/keyboard/vim", (m) => {
                      const VimApi = window.ace.require("ace/keyboard/vim").CodeMirror.Vim;
                      if(!VimApi.defineExDone) {
                        VimApi.defineEx("write", "w", (cm, input) => {
                          cm.ace.execCommand("save");
                        });
                        VimApi.defineEx("quit", "q", (cm, input) => {
                          cm.ace.execCommand("quit");
                        });
                        VimApi.defineExDone = true;
                      }
                    });
                  }
                }
                resize();
              }
            });
            scope.$watch('currentUser.applicationConfigs.editor.general.theme', (post, pre) => {
              if(!post){
                return;
              }
              const theme = appConfig.general.theme;
              if (scope.aceTheme !== theme){
                scope.aceTheme = theme;
                resize();
              }
            });
            scope.$watch('currentUser.applicationConfigs.editor.general.enableEmmet', (post, pre) => {
              if(!post){
                return;
              }
              const enableEmmet = appConfig.general.enableEmmet;
              if (scope.aceOptions.enableEmmet !== enableEmmet){
                if(scope.acemode === 'html') {
                  scope.aceOptions.enableEmmet = enableEmmet;
                  if (enableEmmet) {
                    scope.aceOptions.enableSnippets = false;
                    scope.aceOptions.enableBasicAutocompletion = false;
                  }else{
                    scope.aceOptions.enableSnippets = true;
                    scope.aceOptions.enableBasicAutocompletion = true;
                  }
                }
              }
            });

            scope.$watch('currentUser.applicationConfigs.editor.general.useWrapMode', (post, pre) => {
              const useWrapMode = appConfig.general.useWrapMode;
              if (scope.aceUseWrapMode !== useWrapMode){
                scope.aceUseWrapMode = useWrapMode;
              }
            });

          });

        },
      },
    };
  });
